module.exports = __webpack_public_path__ + "img/sales_report.9dba0b4a.png";